<ag-grid-angular #dispositionsWidgetGrid
                 *ngIf="gridOptions != null"
                 [hidden]="!isFirstDataLoaded"
                 class="ag-theme-balham flex-fill"
                 [gridOptions]="gridOptions"
                 style="height:100%; width:100%;"></ag-grid-angular>
